import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { SizeProp } from "@fortawesome/fontawesome-svg-core";
import Box from "@mui/material/Box";
import { shortUuidIcons } from "@egalregal/shared";
import { labelIcon } from "./labelIcons";

interface ShortUuidIconsProps {
  uuid: string;
  size?: SizeProp;
  /** Stretch mode spreads the four icons across the full width. */
  stretch?: boolean;
}

/** The four short-UUID pictograms for a container (ADR-0027); decorative. */
export function ShortUuidIcons({ uuid, size = "lg", stretch = false }: ShortUuidIconsProps) {
  const icons = shortUuidIcons(uuid);
  return (
    <Box
      component="span"
      data-testid="short-uuid-icons"
      aria-hidden="true"
      sx={
        stretch
          ? { display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }
          : { display: "inline-flex", alignItems: "center", gap: 0.5 }
      }
    >
      {icons.map((name, i) => (
        <Box
          component="span"
          key={`${name}-${i}`}
          sx={stretch ? { flex: "1 1 0", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" } : undefined}
        >
          <FontAwesomeIcon
            icon={labelIcon(name)}
            size={size}
            style={stretch ? { width: "75%", height: "auto", display: "block", margin: "0 auto" } : undefined}
          />
        </Box>
      ))}
    </Box>
  );
}